module.exports = __webpack_public_path__ + "img/4b1e098.jpg";